import { useSuspenseQuery } from '@apollo/client';
import { Suspense, type FC } from 'react';
import { GET_ORGANIZATION_NAME } from './query';
import { Skeleton, Typography, type TypographyProps } from '@mui/material';
import ApolloErrorBoundary from '@components/ApolloErrorBoundary';

interface Props {
  organizationId?: number;
  showId?: boolean;
}

const Component: FC<Props & TypographyProps> = ({ organizationId, showId, ...typographyProps }) => {
  const { data } = useSuspenseQuery(GET_ORGANIZATION_NAME, {
    variables: { input: organizationId != null ? { id: organizationId } : null },
  });
  return (
    <Typography variant="inherit" component="span" {...typographyProps}>
      {showId ? `${data.organization.id} - ` : ''}
      {data.organization.name}
    </Typography>
  );
};

const Fallback: FC<TypographyProps> = (props) => {
  return (
    <Skeleton variant="text" sx={{ display: 'inline', ...props }}>
      <Typography variant="inherit" component="span" {...props}>
        placeholder
      </Typography>
    </Skeleton>
  );
};

const UserNameSpan: FC<Props & TypographyProps> = (props) => {
  const { organizationId: userId, ...typographyProps } = props;
  return (
    <ApolloErrorBoundary variant="section-alert">
      <Suspense fallback={<Fallback {...typographyProps} />}>
        <Component {...props} />
      </Suspense>
    </ApolloErrorBoundary>
  );
};

export default UserNameSpan;
